import { render, staticRenderFns } from "./drawTypeDialog.vue?vue&type=template&id=6bef348c&scoped=true"
import script from "./drawTypeDialog.vue?vue&type=script&lang=js"
export * from "./drawTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./drawTypeDialog.vue?vue&type=style&index=0&id=6bef348c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef348c",
  null
  
)

export default component.exports